import React, { createContext, useContext, useReducer, useEffect, useState } from "react";

/* ══════════════════════════════════════
   CART CONTEXT
   ══════════════════════════════════════ */
const CartContext = createContext(null);
const CustomerCtx = createContext(null);

function cartReducer(state, action) {
  switch (action.type) {
    case "ADD": {
      const exists = state.find(i => i.id === action.item.id);
      if (exists) {
        return state.map(i =>
          i.id === action.item.id
            ? { ...i, qty: Math.min(i.qty + action.item.qty, i.quantity) }
            : i
        );
      }
      return [...state, { ...action.item, qty: action.item.qty || 1 }];
    }
    case "REMOVE":
      return state.filter(i => i.id !== action.id);
    case "SET_QTY":
      return state.map(i =>
        i.id === action.id ? { ...i, qty: Math.max(1, Math.min(action.qty, i.quantity)) } : i
      );
    case "CLEAR":
      return [];
    default:
      return state;
  }
}

export function ShopProvider({ children }) {
  // ── Cart ──
  const [cart, dispatch] = useReducer(cartReducer, [], () => {
    try { return JSON.parse(localStorage.getItem("noel_cart") || "[]"); } catch { return []; }
  });

  useEffect(() => {
    localStorage.setItem("noel_cart", JSON.stringify(cart));
  }, [cart]);

  const addToCart      = (item, qty = 1) => dispatch({ type: "ADD",     item: { ...item, qty } });
  const removeFromCart = (id)            => dispatch({ type: "REMOVE",  id });
  const setQty         = (id, qty)       => dispatch({ type: "SET_QTY", id, qty });
  const clearCart      = ()              => dispatch({ type: "CLEAR" });

  const cartTotal = cart.reduce((s, i) => s + Number(i.sale_price || i.price) * i.qty, 0);
  const cartCount = cart.reduce((s, i) => s + i.qty, 0);

  // ── Customer Auth ──
  const [customer, setCustomer] = useState(() => {
    try { return JSON.parse(localStorage.getItem("noel_customer") || "null"); } catch { return null; }
  });
  const [token, setToken] = useState(() => localStorage.getItem("noel_token") || null);

  const loginCustomer = (customerData, jwt) => {
    setCustomer(customerData);
    setToken(jwt);
    localStorage.setItem("noel_customer", JSON.stringify(customerData));
    localStorage.setItem("noel_token", jwt);
  };

  const logoutCustomer = () => {
    setCustomer(null);
    setToken(null);
    localStorage.removeItem("noel_customer");
    localStorage.removeItem("noel_token");
  };

  return (
    <CartContext.Provider value={{ cart, addToCart, removeFromCart, setQty, clearCart, cartTotal, cartCount }}>
      <CustomerCtx.Provider value={{
        customer,
        token,
        loginCustomer,
        logoutCustomer,
        // Aliases so Cart.jsx / ShopDetail.jsx work without changes
        login:  loginCustomer,
        logout: logoutCustomer,
      }}>
        {children}
      </CustomerCtx.Provider>
    </CartContext.Provider>
  );
}

export const useCart     = () => useContext(CartContext);
export const useCustomer = () => useContext(CustomerCtx);